import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {RegistrationRequestDtoModel} from '../../data-transfer-objects/registration-request-dto.model';

@Injectable({providedIn: 'root'})
export class RegistrationRequestService extends BaseApiTemplateService<RegistrationRequestDtoModel> {

  constructor(httpClient: HttpClient) {

    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + '/identity/registration';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + '/identity/registration';
    this.httpClient = httpClient;
  }

  registerUserWithTenantCode(dtoObject: RegistrationRequestDtoModel, tenantCode?: string) {
    if (!tenantCode) {
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'identity/registration';
    } else {
      // tslint:disable-next-line:max-line-length
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'identity/registration?tenantCode=' + tenantCode;
    }
    return this.httpClient.post(this.apiUrl, dtoObject);
  }

}
